import { STOPS_VALUE_TYPES } from 'v2/common/constants/index';

export const getTypeBasedValue = (type) => {
  switch (type) {
    case STOPS_VALUE_TYPES.Amount:
      return 'lossAmount';
    case STOPS_VALUE_TYPES.Points:
      return 'lossPoints';
    default:
      return 'lossPercentage';
  }
};

export const buildLegProperty = (identifier, property) => {
  const { caseIndex, label } = identifier;

  return `case.${caseIndex}.leg.${label}.${property}`;
};
